module.exports = {
	"amp": "&",
	"apos": "'",
	"gt": ">",
	"lt": "<",
	"quot": "\""
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/entities/maps/xml.json
 ** module id = 174
 ** module chunks = 0
 **/